import React from "react"
import { LOADING_TEXT } from "../../constants"
import { Loader, Modal } from "../../UIKit/components"

export default function LoadingModal({ isOpen }) {
  return (
    <Modal
      isOpen={isOpen}
      allowClose={false}
      body={<Loader />}
      title={LOADING_TEXT}
    />
  )
}
